import script from "./RecTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecTextarea.vue?vue&type=script&setup=true&lang=ts"

import "./RecTextarea.vue?vue&type=style&index=0&id=763ee758&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763ee758"]])

export default __exports__